import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
export const GET_ACTION_OUTPUT_FIELDS_FIELDNAME = 'getActionOutputFields';
export const GET_ACTION_OUTPUT_FIELDS = registerQuery({
  fieldName: GET_ACTION_OUTPUT_FIELDS_FIELDNAME,
  args: ['actionTypeId'],
  fetcher({
    actionTypeId
  }) {
    return http.get(`automationplatform/v1/output-fields/action-type-id/${actionTypeId}`).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo
      });
      return [];
    });
  }
});
const createOutputFieldsByName = (fields = []) => {
  return fields.reduce((acc, field) => {
    var _field$typeDefinition, _field$typeDefinition2;
    if ((_field$typeDefinition = field.typeDefinition) !== null && _field$typeDefinition !== void 0 && _field$typeDefinition.name && (_field$typeDefinition2 = field.typeDefinition) !== null && _field$typeDefinition2 !== void 0 && _field$typeDefinition2.label) {
      acc[field.typeDefinition.name] = field.typeDefinition.label;
    }
    return acc;
  }, {});
};
export const useActionOutputFields = ({
  actionTypeId
}) => {
  var _query$data;
  const query = useQuery(GET_ACTION_OUTPUT_FIELDS, {
    variables: {
      actionTypeId: actionTypeId || ''
    },
    fetchPolicy: 'cache-first',
    skip: !actionTypeId
  });
  const outputFieldsByName = (_query$data = query.data) !== null && _query$data !== void 0 && _query$data.getActionOutputFields ? createOutputFieldsByName(query.data.getActionOutputFields) : {};
  return Object.assign({}, query, {
    outputFieldsByName
  });
};